<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card>
          <template slot="actions">
            <vs-button @click="onClickShipmentCreate" class="mr-4" color="primary" type="filled">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table
              id="courier-shipments-table"
              :max-documents="(meta.per_page) ? meta.per_page : 10"
              :data="documents"
              sort
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="20%">NAME</vs-th>
                <vs-th>DESCRIPTION</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td>
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    {{ data[indextr].description}}
                  </vs-td>

                  <vs-td >
                    <div class="vx-row">
                      <vx-tooltip class="ml-0" text="View/Update" position="left">
<!--                        <vs-button @click.stop="onClickUpdateShipment(data[indextr].id)"-->
<!--                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>-->
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxdocuments="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-documents="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-documents="descriptiondocuments"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <create-courier-service-pop-up ref="createCourierServicePopUp"/>
    <update-product-order-shipment-pop-up ref="updateProductOrderShipmentPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CourierRepository = RepositoryFactory.get('courier')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";

  import CreateCourierServicePopUp from "@/components/popups/courier/CreateCourierServicePopUp";
  import UpdateProductOrderShipmentPopUp
    from "@/components/popups/customer/product-orders/UpdateProductOrderShipmentPopUp";


  export default {
    name: 'CourierSupplierShipmenList',
    data () {
      return {
        documents: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        id: '',
        perPage: defaultPagination,
        descriptiondocuments: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      CreateCourierServicePopUp,
      UpdateProductOrderShipmentPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.id = this.$route.params.id
    },
    methods: {
      async refreshData () {
        this.fetchSundrySupplierDocuments()
      },
      async onClickSupplierView (id) {
        this.$router.push({path: `/pages/manage-nimble/suppliers/sundry/${id}`})
      },
      async fetchSundrySupplierDocuments() {
        await this.$vs.loading({
          container: '#courier-shipments-table',
          scale: 0.45
        })
          const {data} = await CourierRepository.listOfCourierServices(this.id, this.page, this.filterQuery, this.perPage, this.sort)
          this.documents =  data.data
          this.meta = data.meta


        this.$vs.loading.close('#courier-shipments-table > .con-vs-loading')
      },
      onClickShipmentCreate() {
        this.$refs.createCourierServicePopUp.openPopup(this.id)
      },
      onClickUpdateShipment(id) {
        this.$refs.updateProductOrderShipmentPopUp.openPopup(id)
      },

      filterQueryUpdate (){
        this.fetchSundrySupplierDocuments()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchSundrySupplierDocuments()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchSundrySupplierDocuments()
        }

      },
      changePage(index) {
        this.perPage = this.descriptiondocuments[index]
      },
    },
    watch : {
      page(){
        this.fetchSundrySupplierDocuments()
      },
      perPage() {
        this.fetchSundrySupplierDocuments()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
